import { REDUCER_NAME } from './const'
import reducer from './reducer'

export {
    reducer,
    REDUCER_NAME,
}




// WEBPACK FOOTER //
// ./src/modules/layout/state/index.js